import { FC } from 'react'
import styled from 'styled-components'

import RotatingArrow from 'components/RotatingArrow'
import Spacer from 'components/Spacer'

const FlexRow = styled.div`
  display: flex;
`

const ZeroHeightSpacer = styled(Spacer)`
  height: 0;
`

const ArrowContainer = styled.div`
  background: ${props => props.theme.colors.yellow5};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
`

interface IProps {
  rotated?: boolean
  fill?: string
  strokecap?: 'butt' | 'rounded'
  noSpacer?: boolean
}
const TopQuestionArrow: FC<IProps> = ({ rotated, fill, strokecap, noSpacer }) => (
  <FlexRow>
    {!noSpacer && <ZeroHeightSpacer size={48} />}
    <ArrowContainer>
      <RotatingArrow
        rotated={rotated}
        strokecap={strokecap}
        fill={fill}
      />
    </ArrowContainer>
  </FlexRow>
)

export default TopQuestionArrow
